export const createInvoiceSubmissionStatuses = {
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
    FAILED_AGAIN: 'FAILED_AGAIN',
    IDLE: 'IDLE',
    LOADING: 'LOADING',
};
